import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Loading } from 'componets/ui';

import { setAuthAdmin } from 'features/authorization/authorizationSlice';
import { useNavigate } from 'react-router-dom';

export const AutoLogin = () => {
	const dispatch = useDispatch();

	const navigate = useNavigate();

	const getUrlParams = useCallback(() => {
		const search = new URLSearchParams(window.location.search);

		const access_token = search.get('accessToken');
		const refresh_token = search.get('refreshToken');

		dispatch(setAuthAdmin({ access_token, refresh_token }));

		navigate('/');

		window.location.reload();
	}, [dispatch, navigate]);

	useEffect(() => {
		getUrlParams();
	}, [getUrlParams]);

	return <Loading />;
};
